module.exports = __webpack_public_path__ + "static/media/0e7fe3e2-7ad1-4c57-8e60-0dd4cb24ff53.79e6dfc3.JPG";